import { useDroppable } from '@dnd-kit/core';
import { SortableContext, verticalListSortingStrategy } from '@dnd-kit/sortable';
import { CandidateCard } from './CandidateCard';
import type { Candidate, FunnelStatus } from '@/types';

interface Props {
  id: FunnelStatus;
  title: string;
  candidates: Candidate[];
  onCardClick: (candidate: Candidate) => void;
  onStatusChange: (id: string, status: FunnelStatus) => void;
}

export function KanbanColumn({ id, title, candidates, onCardClick, onStatusChange }: Props) {
  const { setNodeRef, isOver } = useDroppable({ id });

  return (
    <div
      className={[
        'flex w-60 shrink-0 flex-col rounded border transition-colors',
        isOver ? 'border-accent/40 bg-bg-elevated' : 'border-border bg-bg-base',
      ].join(' ')}
    >
      {/* Column header */}
      <div className="flex items-center justify-between border-b border-border px-3 py-2">
        <span className="text-2xs font-semibold uppercase tracking-widest text-text-muted">
          {title}
        </span>
        <span className="font-mono text-2xs text-text-muted tabular-nums">
          {candidates.length}
        </span>
      </div>

      {/* Drop zone */}
      <div
        ref={setNodeRef}
        className="flex flex-1 flex-col gap-1.5 p-1.5 min-h-[100px]"
      >
        <SortableContext
          items={candidates.map((c) => c.id)}
          strategy={verticalListSortingStrategy}
        >
          {candidates.map((c) => (
            <CandidateCard
              key={c.id}
              candidate={c}
              onClick={() => onCardClick(c)}
              onStatusChange={onStatusChange}
            />
          ))}
        </SortableContext>

        {candidates.length === 0 && (
          <div className="flex flex-1 items-center justify-center rounded border border-dashed border-border py-8">
            <span className="text-2xs text-text-muted">vazio</span>
          </div>
        )}
      </div>
    </div>
  );
}
